<template>
  <div>
    <section class="container-fluid my-4 col-md-10 offset-md-2">
      <h4 class="my-4">
        Relação de <strong>Filiais Autorizadas</strong>
        <router-link
          :to="{ name: 'branch-register' }"
          class="btn btn-success btn-sm ms-3 text-white"
        >
          + Nova Filial
        </router-link>
      </h4>

      <div class="well mb-4">
        <input
          type="text"
          class="form-control"
          placeholder="Filtrar por nome"
          v-model="search"
        />
      </div>

      <table class="table table-bordered table-striped table-hover">
        <thead>
          <tr>
            <th>#</th>
            <th>Nome</th>
            <th>CNPJ</th>
            <th>Cidade / UF</th>
            <th>Responsável</th>
            <th>Código INEP</th>
            <th width="98px"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in filteredItems" :key="item.id">
            <td>{{ item.id }}</td>
            <td>{{ item.name }}</td>
            <td>{{ item.cnpj }}</td>
            <td>{{ item.city }} / {{ item.uf }}</td>
            <td>{{ item.responsible }}</td>
            <td>{{ item.inep_code || "-" }}</td>
            <td>
              <ButtonEdit
                :to="{ name: 'branch-edit', params: { id: item.id } }"
              />
              <ButtonDelete @delete="removeItem(item.id)" />
            </td>
          </tr>
          <tr v-if="!filteredItems.length">
            <td colspan="7" class="text-center text-muted">
              Nenhuma filial cadastrada.
            </td>
          </tr>
        </tbody>
      </table>

      <Pagination :source="pagination" @navigate="navigate" />
    </section>
  </div>
</template>

<script>
import api from "@/services";
import Pagination from "@/components/Pagination.vue";
import ButtonEdit from "@/components/ButtonEdit.vue";
import ButtonDelete from "@/components/ButtonDelete.vue";
import { serialize } from "@/helpers";

export default {
  name: "BranchList",
  components: { Pagination, ButtonEdit, ButtonDelete },
  data() {
    return {
      items: [],
      search: "",
      pagination: {},
      currentPage: 1,
    };
  },
  computed: {
    filteredItems() {
      if (!this.search) return this.items;
      const q = this.search.toLowerCase();
      return this.items.filter((i) => i.name.toLowerCase().includes(q));
    },
  },
  methods: {
    async getItems(page = 1) {
      const params = serialize({ page, perPage: 20 });
      await api.get(`/branches?${params}`).then((res) => {
        this.items = res.data.data;
        this.pagination = res.data.meta || res.data.pagination || {};
      });
    },
    navigate(page) {
      this.currentPage = page;
      this.getItems(page);
    },
    async removeItem(id) {
      try {
        const res = await api.delete(`/branches/${id}`);
        Toast.fire(res.data.message, "", "success");
        this.getItems(this.currentPage);
      } catch (error) {
        Toast.fire(error.response.data.message, "", "error");
      }
    },
  },
  mounted() {
    this.getItems();
  },
};
</script>
